<script setup lang="ts">
import { useZipCode } from '@/composables/useZipCode'
import { FormSchema } from '@/pages/carts/show.vue'
import { inject, provide, ref } from 'vue'
import Title from '../Title.vue'
import Company from './Company.vue'
import Individual from './Individual.vue'

const emit = defineEmits(['updateStep'])

const { form } = defineProps<{
    form: FormSchema
}>()

const paymentMethod = inject<string>('selectedPaymentMethod')

const { isLoading, searchAddressByZipCode } = useZipCode()

const storedCity = ref('')
provide('storedCity', storedCity)

const onZipCodeSearch = async () => {
    const previousState = form.state

    const result = await searchAddressByZipCode(form.zip_code)
    if (!result) return

    const regionCode = result.region_code || result.state || ''

    form.street = result.street
    form.district = result.district
    form.region_code = regionCode
    form.state = regionCode
    form.city = result.city
    form.country = result.country

    if (previousState !== result.state) {
        storedCity.value = result.city
    }
}
</script>

<template>
    <div>
        <div class="mb-8"><Title :title="$t('Data for issuing an invoice')" :description="$t('Enter your personal data')" /></div>
        <Company v-if="paymentMethod === 'company_billing'" :form="form" :isLoading="isLoading" @searchAddressByZipCode="onZipCodeSearch" />
        <Individual v-else :form="form" :isLoading="isLoading" @searchAddressByZipCode="onZipCodeSearch" />
    </div>
</template>
